import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';

const GET_NCAAFB_MATCHUPS = gql`
  query GetNcaafbMatchups($useDummyDate: Boolean) {
    ncaafbMatchups(useDummyDate: $useDummyDate) {
      startTime
      oTeam
      team
      site
      streak
      ouStreak
      atsStreak
      oStreak
      oOuStreak
      oAtsStreak
      school
      oSchool
      rest
      oRest
      playoffs
      line
      oLine
      date
      total
      wins
      losses
      oWins
      oLosses
      division
      oDivision
      conference
      oConference
      conference
      oConference
      division
      oDivision
      pConference
      opConference
      pDivision
      opDivision
      rank
      oRank
      week
      month
      activeTrends {
        isAtsTrend
        isSuTrend
        isOuTrend
        atsWins
        atsLosses
        overs
        unders
        wins
        losses
        oPoints
        points
        trend
        trendDescription
        activeGames {
          activeDate
          activeOTeam
          activeTeam
        }
      }
    }
  }
`;

export const useGetNcaafbMatchups = (
    useDummyDate: boolean = false,
    skip: boolean = false,
    isLoggedIn: boolean = false
) => {
    const { data, loading, error, refetch } = useQuery(GET_NCAAFB_MATCHUPS, {
        variables: { useDummyDate },
        skip,
        // fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (!skip && isLoggedIn) {
            refetch();
        }
    }, [isLoggedIn, useDummyDate, skip, refetch]);

    return { data, loading, error, refetch };
};